import BaseStore, { DownloadStore } from "@/Services/BaseService";

export const getAllDeliveries = async (params) => {
    try {
        const response = await BaseStore.get('/delivery', {
            params
        });

        if (!response) {
            console.log('getAllDeliveries response', response)
        }
        return response?.data;
    } catch (error) {
        return Promise.reject(error);
    }
};


export const getAllDeliveriesForExport = async (params) => {
    try {
        const response = await DownloadStore.get('/delivery', {
            params
        });

        if (!response) {
            console.log('getAllDeliveriesForExport response', response)
        }
        return response?.data;
    } catch (error) {
        return Promise.reject(error);
    }
};

export const createDelivery = async (body) => {
    try {
        const response = await BaseStore.post('/delivery', body);
        return response?.data;
    } catch (error) {
        return Promise.reject(error);
    }
};

export const getDeliveryDetailsbyId = async (deliveryId) => {
    try {
        const response = await BaseStore.get(`/delivery/${encodeURIComponent(deliveryId)}`);
        
        if (!response) {
            console.log('getAllDeliveries response', response)
        }
        
        return response?.data;
    } catch (error) {
        return Promise.reject(error);
    }
};

export const closeDeliverybyId = async (deliveryId) => {
    try {
        const response = await BaseStore.put(`/delivery/close-by-deliveryId/${deliveryId}`);
        return response?.data;
    } catch (error) {
        return Promise.reject(error);
    }
};

export const closeDeliverybyDateRange = async (routeId,startdate,endDate) => {
    try {
        const response = await BaseStore.put(`/delivery/close-by-date-range/${routeId}/${startdate}/${endDate}`);
        return response?.data;
    } catch (error) {
        return Promise.reject(error);
    }
};

export const closeDeliverybyRoute = async (route) => {
    try {
        const response = await BaseStore.put(`/delivery/close-by-route/${route}`);
        return response?.data;
    } catch (error) {
        return Promise.reject(error);
    }
};

